__turbopack_context__.v({
  "className": "inter_e8e54af-module__r7opxW__className",
  "variable": "inter_e8e54af-module__r7opxW__variable",
});
